import axios from "axios";

//  获取中文名
function packageStatusConver(statusCode) {
  if (statusCode === "NW") {
    return "新建";
  } else if (statusCode === "QS") {
    return "签收";
  } else if (statusCode === "WRRL") {
    return "无人认领";
  } else if (statusCode === "YPH") {
    return "已配货";
  } else if (statusCode === "CF") {
    return "确认订单";
  } else if (statusCode === "PT") {
    return "预报订单";
  } else if (statusCode === "NP") {
    return "暂不处理";
  }
  return statusCode;
}
function verification() {
  axios.post("/api/packageStatusCount.htm").then(res => {
  });
}

const getDay = day => {
  const doHandleMonth = month => {
    var m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  };
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + "-" + tMonth + "-" + tDate;
};
const getDays = day => {
  const doHandleMonth = month => {
    var m = month;
    if (month.toString().length == 1) {
      m = "0" + month;
    }
    return m;
  };
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds); //注意，这行是关键代码
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + "," + tMonth + "," + tDate;
};

const loadFile = function () {
  // name为文件所在位置
  let xhr = new XMLHttpRequest(),
    okStatus = document.location.protocol === "file:" ? 0 : 200;
  xhr.open("GET", name, false);
  xhr.overrideMimeType("text/html;charset=utf-8"); //默认为utf-8
  xhr.send(null);
  return xhr.status === okStatus ? xhr.responseText : null;
};
export { packageStatusConver, verification, loadFile, getDay, getDays };
